import React from 'react';
import { useStyletron } from 'baseui';
import { StyledLink } from 'baseui/link';
import Router from 'next/router';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { COMPLETE_ID, COOKIE_NAMES, MATCHED_ID, PENDING_ID, SCOPING_ID } from '@gtintel/platform-constants';
import { UserRole } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import { ActivateProjectButton, CloseProjectButton, ScopingProjectButton } from '../../../../components/Buttons';
import { ProjectContext } from '../../../context';
const router = Router;
const handleViewReport = () => {
  if (alreadyExistsTabDetail()) {
    return router.asPath;
  }
  return `${router.asPath}?tab=2`;
};
const alreadyExistsTabDetail = () => {
  const {
    tab
  } = router.query;
  return !!tab;
};
const ActionButtons = () => {
  const {
    status,
    reports,
    declineNetworkPartner
  } = React.useContext(ProjectContext);
  const [css] = useStyletron();
  const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
  const isAnalyst = Number(user?.role) === UserRole.Analyst;
  return <section className={css({
    margin: '18px 0'
  })}>
      {status() === PENDING_ID && !isAnalyst && <ButtonRow>
          <CloseProjectButton />
        </ButtonRow>}

      {status() === MATCHED_ID && <ButtonRow>
          <ScopingProjectButton />
          {!isAnalyst && <>
              <ActivateProjectButton />
              <CloseProjectButton />
            </>}
        </ButtonRow>}

      {status() === SCOPING_ID && <div className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    })}>
          <ButtonRow>
            {!isAnalyst && <ActivateProjectButton />}
            {!isAnalyst && <CloseProjectButton />}
          </ButtonRow>
          <Button kind="error" testId="decline-network-partner-button" onClick={() => declineNetworkPartner()}>
            Decline Network Partner
          </Button>
        </div>}

      {status() === COMPLETE_ID && !isAnalyst && !reports() && <CloseProjectButton />}

      {reports().length > 0 && <ButtonRow>
          {reports().map(report => {
        if (report.state['value'] === '2' && status() === COMPLETE_ID && !isAnalyst) {
          return <>
                  <CloseProjectButton />
                  <StyledLink href={handleViewReport()}>View Report</StyledLink>
                </>;
        }
      })}
        </ButtonRow>}
    </section>;
};
export default ActionButtons;